<script>
    import Swipe from '../../utils/Swipe.js';
    import { outerWidth } from '../../utils/dom.js';
    import PagingIndicator from './shared/PagingIndicator.vue';
    export default {
        components: { 'paging-indicator': PagingIndicator },
        data() {
            return {
                itemCount: 0,
                itemInViewIndex: 0,
                liftUpWidth: 380,
                liftups: []
            };
        },
        computed: {
            carouselTransform() {
                return { transform: `translateX(-${this.itemInViewIndex * this.liftUpWidth}px)` };
            },
            scrollRightDisabled() {
                return (this.itemCount && this.itemInViewIndex >= (this.itemCount - 1));
            },
            scrollLeftDisabled() {
                return this.itemInViewIndex < 1;
            }
        },
        methods: {
            scrollLeft() {
                this.itemInViewIndex = Math.max(0, this.itemInViewIndex - 1);
            },
            scrollRight() {
                this.updateLiftupWidth();
                this.itemInViewIndex = Math.min(this.itemCount - 1, this.itemInViewIndex + 1);
            },
            updateLiftupWidth() {
                if ((this.liftups || []).length > 1) {
                    this.liftUpWidth = outerWidth(this.liftups[1]) + (window.innerWidth > 721 ? 23 : 18);
                }
            },
            handlePageChange(evt) {
                this.itemInViewIndex = evt.pageStart;
            }
        },
        mounted() {
            this.liftups = this.$refs.tilewrapper.querySelectorAll('.liftup-card');
            this.itemCount = (this.liftups || []).length;
            if (this.itemCount > 1) {
                window.addEventListener('resize', this.updateLiftupWidth);
                this.updateLiftupWidth();
                const swipeCarousel = new Swipe(this.$refs.carousel).onLeft(this.scrollRight).onRight(this.scrollLeft);
                swipeCarousel.run();
            }
        },
        unmounted() {
            window.removeEventListener('resize', this.updateLiftupWidth);
        }
    };
</script>